export const getMonth = () => {
  const res = new Date()
    .toLocaleString('en', { month: 'long' }).toLowerCase()

  if (
    res == "july" ||
    res == "august" ||
    res == "september" ||
    res == "october" ||
    res == "november" ||
    res == "december"
  ) {
    return "june"
  }

  return res
}